import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'
import utils from '@/util'

const _state = {}
const _getters = {
  isAhaSlidesGPTEnabled: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-ai-aha-gpt') && !utils.checkWhiteLabelDomain()
  },
  ahaGPTUrl: (_, __, ___, rootGetters) => {
    if (rootGetters.isStagingEU) {
      return 'https://chatgpt.com/g/g-68244b4057e481918f738a2c66f7ac9d-ahaslides-staging-eu'
    }
    if (rootGetters.isCanaryEU) {
      return 'https://chatgpt.com/g/g-68244c2dde9c8191893f1472a12cf517-ahaslides-gpt-canary'
    }
    if (rootGetters.isProductionEU) {
      return 'https://chatgpt.com/g/g-68244c9d1cbc8191998b1abb64902a09-official-ahaslides-gpt-eu'
    }
    if (rootGetters.isStagingGlobal) {
      return 'https://chatgpt.com/g/g-6801d4b8ad6481918b1f3f76d52feb81-ahaslides-staging'
    }
    if (rootGetters.isCanaryGlobal) {
      return 'https://chatgpt.com/g/g-6801d7261830819199f688c2cad6792c-ahaslides-canary'
    }
    return 'https://chatgpt.com/g/g-680af02c81e08191bcfc4ea11cbba343-official-ahaslides-gpt'
  },
}
const mutations = {}
const actions = {}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
